import { Component, computed, inject, input, output } from "@angular/core";
import { AreaType } from 'src/models/area-builder/area-type.enum';
import { environment } from "src/environments/environment";
import { EvTooltipModule } from "ev-tooltip";
import { EvCircularProgressComponent } from "src/app/shared-components/ev-circular-progress/ev-circular-progress.component";
import { EvKeyValuePairModule } from "ev-key-value-pair";
import { INewDwellingInfo, INewDwellingProjectInfo, INewDwellingPublication } from "src/app/infopage/new-new-dwelling/newdwelling.model";
import { ThreeDotNavigationComponent } from "../threedot-navigation/threedot-navigation.component";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { ConvertUtil } from "src/util/tools/convert.util";
import { EVNDSaleStateType } from "src/models/new-dwelling/new-dwelling.enums";
import { NewDwellingDataService } from "src/app/infopage/services/new-dwelling-data.service";

@Component({
    selector: "stage-header",
    templateUrl: "./stage-header.component.html",
    styleUrl: "./stage-header.component.scss",
    imports: [ThreeDotNavigationComponent, EvTooltipModule, EvCircularProgressComponent, EvKeyValuePairModule],
})

export class StageHeaderComponent {
    private readonly newDwellingService = inject(NewDwellingDataService);

    projectStage = input<INewDwellingInfo>();
    projectInfo = input<INewDwellingProjectInfo>();
    publications = input<INewDwellingPublication[]>([]);
    mapMode = input<boolean>(false);

    protected readonly stageMode = computed(() => this.newDwellingService.pseid() != null);

    EvAreaType = AreaType;
    EVNDSaleStateType = EVNDSaleStateType;
    
    cadastreDialogVisible = false;

    public readonly colorGreen15 = ['#A7DD74', '#65983D'];
    public readonly colorBlue20 = ['#3d91c6', '#115389'];

    cadastre = computed(() => {
        const projectStage = this.projectStage();
        if (projectStage?.gnr && projectStage?.bnr) {
            const identificationText =
                (projectStage.kNr || "0") + "-" + (projectStage.gnr || "0") + "/" + (projectStage.bnr || "0") + "/" + (projectStage.fnr || "0") + "/" + (projectStage.snr || "0");

            return identificationText;
        }
        return null;
    });

    statusDate = computed(() => {
        const statusdate = this.projectStage()?.statusDate || this.projectInfo()?.statusDate;
        return statusdate ? new Date(statusdate).toLocaleDateString("no-NO", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";
    });

    percentSold = computed(() => {
        const dwelling = this.projectStage();
        if (dwelling?.numUnits && dwelling.numUnits > 0) {
            return Math.round((dwelling.numberSold ?? 0) / dwelling.numUnits * 100);
        }
        return 0;
    });

    estateTypeCssClass = computed(() => {
        const estateType = ConvertUtil.estateTypeToCssString(this.projectStage()?.estateType ?? EVEstateType.Annet);
        return `property-${estateType}`;
    });

    protected navigateToMap(areaId: number, areaTypeId: number): void {
        const link = `/map/new-dwellings/market?areaId=${areaId}&areaTypeId=${areaTypeId}`;
        window.location.href = link;
    }
}
